import { jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
export const DEFAULT_CHIP_AS = "span";
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const Chip = ({ as, disabled, size = "medium", beforeSlot, afterSlot, className, hasBorder, children, ...rest }) => {
    const Tag = as || DEFAULT_CHIP_AS;
    return (_jsxs(Tag, { className: classNames(`eds-chip`, `eds-chip--${size}`, { "eds-chip--disabled": disabled, "eds-chip--border": hasBorder }, className), ...{ disabled }, ...rest, children: [beforeSlot, children, afterSlot] }));
};
